import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Heading } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/heading";
import { OverviewButton } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/overview-button";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group";
import { ContentBoxElements } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox";
import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon";
import { useWindowSize } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/size-detector";
import { PopUpMenu } from "@com.mgmtp.a12.widgets/widgets-core/lib/pop-up-menu/main/pop-up-menu.view";

import { MobileNavigationContext } from "../../app/mobileNavigationContext";

import { ActivityIdContext } from "../ActivityContext";

export const CustomOverviewHeading: React.ComponentType<Heading.PropsType> = function CustomOverviewHeading({
	title,
	buttons: buttonsNode,
	ariaLevel,
	additionalControls,
	searchButton,
	filterSelector
}: Heading.PropsType) {
	const navigationContext = React.useContext(MobileNavigationContext);
	const activityId = React.useContext(ActivityIdContext);

	if (!activityId) {
		throw new Error("Missing ActivityIdContext.");
	}

	const dispatch = useDispatch();

	const { size } = useWindowSize().breakPoint ?? { size: "md" };
	const isSmall = size === "sm" || size === "xs";

	const onBackButtonClicked = navigationContext?.onBackButtonClicked;
	const backButton =
		onBackButtonClicked && isSmall ? (
			<ContentBoxElements.BackButton onBackButtonClicked={navigationContext?.onBackButtonClicked} />
		) : undefined;

	const handleClose = useCallback(() => dispatch(ActivityActions.cancel({ activityId })), [activityId]);
	const buttons = (buttonsNode || []) as React.FunctionComponentElement<OverviewButton.Props>[];
	return (
		<ContentBoxElements.Heading
			prefixes={<>{backButton}</>}
			suffixes={
				<>
					{additionalControls}
					{searchButton}
					{filterSelector}
					{isSmall && buttons?.length > 0 ? (
						<ContentBoxElements.HeadingAddon>
							<PopUpMenu icon={<Icon>more_vert</Icon>} disabled={false}>
								{buttons}
							</PopUpMenu>
						</ContentBoxElements.HeadingAddon>
					) : null}
					<ButtonGroup>
						<Button title="Schließen" icon={<Icon>close</Icon>} secondary onClick={handleClose} />
					</ButtonGroup>
				</>
			}
		>
			<ContentBoxElements.Title ariaLevel={ariaLevel} text={title} />
		</ContentBoxElements.Heading>
	);
};
